module.exports = __webpack_public_path__ + "static/media/gw.df5e99ae.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gw.svg
// module id = 2107
// module chunks = 0